import { Avatar, Box, ButtonBase, Stack, Typography } from '@mui/material';
import { ControlledAutocomplete } from 'Components/ControlledAutoComplete';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleX } from 'Images';
import { useContext, useState } from 'react';

export const PaymentDeductionNumber = () => {
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const [inputValue, setInputValue] = useState('');

  const setRequestNumber = (requestNumber: string | null) => {
    dispatchAdvancedSearch({
      type: 'REQUEST_NUMBER',
      payload: { value: requestNumber },
    });
  };

  const onClickDelete = () => {
    setRequestNumber(null);
    setInputValue('');
  };

  return (
    <Box position={'relative'} top={'-2px'}>
      <ControlledAutocomplete
        freeSolo
        label={
          Dictionary[DICTIONARY.PaymentsDeductions].search.accordingToNumber
        }
        options={advancedSearch.requestNumberList}
        value={advancedSearch.requestNumber?.toString() || ''}
        setValue={setRequestNumber}
        inputValue={inputValue}
        setInputValue={setInputValue}
        inputProps={{ inputMode: 'decimal' }}
        paperComponent={
          inputValue.length !== 0 &&
          advancedSearch.requestNumberList.filter((value) =>
            value.includes(inputValue)
          ).length === 0 && (
            <Stack>
              <Typography variant={'body3'}>
                {Dictionary[DICTIONARY.PaymentsDeductions].search.noResult}
              </Typography>
            </Stack>
          )
        }
        disableClearIcon
        endAdornment={
          <Stack
            direction={'row'}
            marginRight={'5px'}
            width={'auto'}
            gap={'15px'}
          >
            {inputValue.length !== 0 && (
              <ButtonBase onClick={onClickDelete}>
                <Avatar
                  alt={''}
                  src={PurpleX}
                  sx={{ width: '20px', height: '20px' }}
                />
              </ButtonBase>
            )}
          </Stack>
        }
      />
    </Box>
  );
};
